import * as React from 'react'
import { cn } from '@/lib/utils'

/** A white content card on the gray canvas: hairline border, faint shadow. */
export function Card({ ref, className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-border bg-card text-card-foreground shadow-card',
        className,
      )}
      {...props}
    />
  )
}

/** The header region of a `Card`. Padding follows density. */
export function CardHeader({ ref, className, ...props }: React.ComponentProps<'div'>) {
  return <div ref={ref} className={cn('flex flex-col gap-1 p-card', className)} {...props} />
}

/** The title line of a `Card` header. */
export function CardTitle({ ref, className, ...props }: React.ComponentProps<'h3'>) {
  return (
    <h3
      ref={ref}
      className={cn('text-title leading-tight font-semibold', className)}
      {...props}
    />
  )
}

/** Secondary descriptive text within a `Card` header. */
export function CardDescription({ ref, className, ...props }: React.ComponentProps<'p'>) {
  return (
    <p ref={ref} className={cn('text-control text-muted-foreground', className)} {...props} />
  )
}

/** The main body region of a `Card`. */
export function CardContent({ ref, className, ...props }: React.ComponentProps<'div'>) {
  return <div ref={ref} className={cn('p-card pt-0', className)} {...props} />
}
